// @ts-strict-ignore
import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {SimEnumExtendedService, SimUtilityService} from "@services";
import {
	Camera,
	CameraConfiguration,
	CameraResolution,
	CameraResolutionType,
	DeviceType,
	TransportProtocol,
	VideoDestinationFormat,
	VideoSourceFormat,
} from "@models";
import {Translations} from "@translations";

export interface DialogData_CameraTemplateDialog extends MatDialogDataBaseInput {
	startIndex?: number;
	defaultResolutions?: CameraResolution[];
}

export interface DialogData_CameraTemplateDialogOutput extends MatDialogDataBaseOutput {
	cameras?: any[];
}

@Component({
	selector: "sim-camera-template-dialog",
	templateUrl: "./camera-template-dialog.component.html",
	styleUrls: ["./camera-template-dialog.component.scss"],
	standalone: false,
})
export class CameraTemplateDialogComponent extends BasicMaterialDialog<
	CameraTemplateDialogComponent,
	DialogData_CameraTemplateDialog,
	DialogData_CameraTemplateDialogOutput
> {
	T = Translations;
	// Dialog private members
	public amount: number = 1;
	public startCameraNumber: number = null;
	public selectedCameraType: DeviceType = null;
	public nameTemplate: string = "Cam [Index]";
	public addressTemplate: string = "cam[Index].simstation.com";

	public cameraTypes: {name: string; value: DeviceType}[] = null;

	constructor(
		_injector: Injector,
		private _simEnumService: SimEnumExtendedService,
	) {
		super(_injector);
		// Initialize
		this.initializeCameraType();
		this.startCameraNumber = this.data.startIndex ?? 0;
	}

	public ok() {
		const cameras: any[] = [];

		for (let i = 0; i < this.amount; i++) {
			const cameraOffset = this.startCameraNumber + i;

			const camera: Partial<Camera> = {
				id: SimUtilityService.createGuid(),
				ipAddress: this.addressTemplate.replace("[Index]", "" + cameraOffset),

				name: this.nameTemplate.replace("[Index]", "" + cameraOffset),
				cameraSourceFormat: VideoSourceFormat.H264,
				cameraDestinationFormat: VideoDestinationFormat.Default,
				delay: 0,
				encodeRecording: false,
				deviceType: this.selectedCameraType,

				isVOG: false,
				isVitalMonitor: false,
				status: 0,
				configuration: <any>(<Partial<CameraConfiguration>>{
					firmewareVersion: "unknown",
					audioSupport: false,
					supportedVideoResolutions: null,
					supportedAudioInputGains: null,

					compression: 0,
					// New Default Value
					ffmpegTransportProtocol: TransportProtocol.Tcp,

					rotation: 0,
					supportedRotations: [0, 180],

					cameraProxy: null,
					cameraProxyType: 0,

					framerate: 25,
					recordAudio: false,
					username: null,
					password: null,

					resolutions: this.data.defaultResolutions.slice(),
				}),
			};

			cameras.push(camera);
		}

		this.close({action: "ok", cameras});
	}

	public cancel() {
		this.close({action: "cancel"});
	}

	private initializeCameraType() {
		// --------------------------- //
		// DeviceType                  //
		// --------------------------- //
		// Standard          = 0       //
		// Epiphan           = 1       //
		// PTZCamera         = 2       //
		// ZoomCamera        = 3       //
		// FFserver          = 4       //
		// EncryptedWebcam   = 5       //
		// ISiumlate         = 6       //
		// InputVideoEncoder = 7       //

		this._simEnumService.getEnumByName("DeviceType").then((getEnumByNameResult) => {
			if (getEnumByNameResult) {
				this.cameraTypes = [];
				getEnumByNameResult.forEach((v) => {
					this.cameraTypes.push({
						name: v.name,
						value: v.intValue,
					});
				});

				this.selectedCameraType = this.cameraTypes[0].value;
			}
		});
	}
}
